import LazyLoad from "vanilla-lazyload";

import "Layouts/default";

import { Vue, i18n } from "Common/vue";

// import components
import NewProducts from "VueComponents/NewProducts.vue";

import "Ui/toggle";
import "Common/country-select";

window.$_newProducts = new Vue({
    i18n,
    render: (h) =>
        h(NewProducts, {
            props: {
                pricesWithVat: Eshop.options.pricesWithVat,
            },
        }),
}).$mount("#new-products");

const branches = window.branchesData;
window.mapLazyLoad = new LazyLoad({
    threshold: 125,
    elements_selector: ".js-map-branches",
    callback_enter: (el) => {
        initializeMap(".js-map-branches", branches);
    },
});
